module.exports = __webpack_public_path__ + "static/media/headlights-and-taillights-red.463a201c.svg";